<div class="content" *ngIf="teklif">
  <div class="container-xl">
    <!-- Page title -->
    <div class="page-header d-print-none">
      <div class="row align-items-center">
        <div class="col">
          <h2 class="page-title text-center">
            VİŞNE MADENCİLİK ÜRETİM SANAYİ VE TİCARET A.Ş.
          </h2>
        </div>
      </div>
    </div>
    <div class="row row-cards">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Teklif İsteme Formu</h3>
          </div>
          <div class="card-body">
            <form>
              <div class="form-group mb-1 row">
                <label class="form-label col-3 col-form-label"><strong>FATURA ADRESİ</strong></label>
                <div class="col">
                  <label class="form-label col-9 col-form-label">Şehit Nevres Bulvarı No.3/7 35210
                    Alsancak/İZMİR</label>
                </div>
              </div>
              <div class="form-group mb-1 row">
                <label class="form-label col-3 col-form-label"><strong>VERGİ DAİRESİ / NO</strong></label>
                <div class="col">
                  <label class="form-label col-9 col-form-label">Kordon / 925 041 0552</label>
                </div>
              </div>
              <div class="form-group mb-1 row">
                <label class="form-label col-3 col-form-label"><strong>TELEFON</strong></label>
                <div class="col">
                  <label class="form-label col-9 col-form-label">+90 232 463 00 03 - FAKS : +90 232 463 11
                    06</label>
                </div>
              </div>
              <div class="form-group mb-4 row">
                <label class="form-label col-12 col-form-label pt-0">TEKNİK SORULARINIZ İÇİN 0322 383 2122'yi
                  ARAYABİLİRSİNİZ.</label>
              </div>
              <div class="form-group mb-1 row">
                <label class="form-label col-12 col-form-label pt-0">SAYIN TEDARİKÇİMİZ ;</label>
                <label class="form-label col-12 col-form-label pt-0">AŞAĞIDA ÖZELLİKLERİ BELİRTİLEN MALZEME VEYA
                  HİZMETİN FİYATLANDIRILMASINI RİCA EDERİZ.</label>
              </div>
              <div class="form-group mb-1 row text-right">
                <label class="form-label col-8 col-form-label"><strong>TALEP TARİHİ:</strong></label>
                <div class="col">
                  <label class="form-label col-4 col-form-label">{{talepTarihi}}</label>
                </div>
              </div>
              <div class="form-group mb-1 row text-right">
                <label class="form-label col-8 col-form-label"><strong>TALEP NO:</strong></label>
                <div class="col">
                  <label class="form-label col-4 col-form-label">{{talepNo}}</label>
                </div>
              </div>

              <div *ngIf="teklif.isGorselGoster" class="col-md-12 col-lg-8">
                <div class="mb-3">
                  <div class="row row-sm">
                    <div class="col-6 col-sm-3 attachment" *ngFor="let g of teklif.talep?.talepGorseller;let index = i">
                      <div class="container">
                        <img [src]="g.getUri()" alt="" class="image" style="width:100%">
                        <div class="middle">
                          <div class="card-body">
                            <div class="d-flex align-items-center">
                              <div class="ml-auto">
                                <a class="text clickable" (click)="downloadFile(g.dosya)">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                    <polyline points="7 11 12 16 17 11"></polyline>
                                    <line x1="12" y1="4" x2="12" y2="16"></line>
                                  </svg>
                                  Görüntüle
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Sipariş Kalemleri</h3>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">Stok Kodu</th>
                  <th>Malzeme Adı ve Özellikleri</th>
                  <th>Ölçü Birimi</th>
                  <th>Miktarı</th>
                  <th>Para Birimi</th>
                  <th>Birim Fiyat</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let k of kalemler;let i=index;">
                  <td><span class="text-muted">{{k?.talepKalem?.stokKodu}}</span></td>
                  <td>{{k?.talepKalem?.stokAdi}}</td>
                  <td>{{k?.talepKalem?.olcuBirimi}}</td>
                  <td>{{k?.talepKalem.talepEdilen}}</td>
                  <app-loading-input *ngIf="paraBirimleri==null"></app-loading-input>
                  <td>
                    <select *ngIf="paraBirimleri" class="form-control" [(ngModel)]="k.paraBirimiId"
                      (change)="toplamTutarHesapla()" [ngModelOptions]="{standalone: true}">
                      <option [value]="null" disabled selected>Şeçiniz</option>
                      <option *ngFor="let p of paraBirimleri" [ngValue]="p.id">{{p.aciklama}}</option>
                    </select>
                  </td>
                  <td><input type="number" class="form-control" [(ngModel)]="k.tutar" (change)="toplamTutarHesapla()">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right">
            <b>Teklif Toplamı:</b> {{totalTutarText}}
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Teklif Detaylar</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <div class="form-label">Teslim Yeri</div>
                  <app-loading-input *ngIf="teslimYerleri==null"></app-loading-input>
                  <select *ngIf="teslimYerleri" class="form-control" [(ngModel)]="teklif.teslimYeriId"
                    [ngModelOptions]="{standalone: true}" [disabled]="true">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of teslimYerleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <div class="form-label">Teslim Şekli</div>
                  <app-loading-input *ngIf="teslimSekilleri==null"></app-loading-input>
                  <select *ngIf="teslimSekilleri" class="form-control" [(ngModel)]="teklif.teslimSekliId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of teslimSekilleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <div class="form-label">Ödeme Yöntemi</div>
                  <label type="text" class="form-control" *ngIf="teklif.cari?.vadeGunu === null else elseBlock">
                    VADE TANIMLI DEĞİL
                  </label>
                  <ng-template #elseBlock>
                    <label class="form-control" *ngIf="teklif.cari?.vadeGunu === '0' else elseBlock2">PEŞİN</label>
                  </ng-template>
                  <ng-template #elseBlock2>
                    <label class="form-control">{{teklif.cari?.vadeGunu}} GÜN VADELİ</label>
                  </ng-template>
                  <!-- <app-loading-input *ngIf="odemeYontemleri==null"></app-loading-input>
                  <select *ngIf="odemeYontemleri" class="form-control" [(ngModel)]="teklif.odemeYontemiId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of odemeYontemleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select> -->
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Teslim Süresi (Gün)</label>
                  <div class="input-icon">
                    <input type="number" class="form-control" [(ngModel)]="teklif.teslimSuresi">
                    <!-- <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text"
                      placeholder="Teslim Tarihi" [(ngModel)]="teklif.teslimTarihi" [altInput]="true"
                      [convertModelValue]="true"> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="mb-3">
                  <div class="form-label">Opsiyon</div>
                  <textarea class="form-control" rows="2" placeholder="Opsiyon" [(ngModel)]="teklif.opsiyon"></textarea>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="mb-3">
                  <div class="form-label">Garanti Süresi</div>
                  <textarea class="form-control" rows="2" placeholder="Garanti Süresi"
                    [(ngModel)]="teklif.garantiSuresi"></textarea>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="mb-3">
                  <div class="form-label">Firma Teklif Notu</div>
                  <textarea class="form-control" rows="2" placeholder="Firma Teklif Notu"
                    [(ngModel)]="teklif.firmaTeklifNotu"></textarea>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-4">
                  <div class="mb-3">
                    <div class="form-label">Görsel</div>
                    <div class="form-file">
                      <input id="fileSelect" type="file" class="form-file-input" accept="image/*"
                        (change)="onFileChanged($event)">
                      <label class="form-file-label" for="fileSelect">
                        <span class="form-file-text">Dosya Seç...</span>
                        <span class="form-file-button">Göz At</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-8">
                  <div class="mb-3">
                    <div class="row row-sm">
                      <div class="col-6 col-sm-3 attachment" *ngFor="let g of teklif.teklifGorseller;let index = i">
                        <div class="container">
                          <img [src]="g.getUri()" alt="" class="image" style="width:100%">
                          <div class="middle">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <div class="ml-auto">
                                  <a class="text clickable" (click)="removeGorsel(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24"
                                      viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                      stroke-linecap="round" stroke-linejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z"></path>
                                      <line x1="18" y1="6" x2="6" y2="18"></line>
                                      <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                    Sil
                                  </a>
                                  <br>
                                  <a class="ml-3 text clickable" (click)="downloadFile(g.dosya)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                                      viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                      stroke-linecap="round" stroke-linejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                      <polyline points="7 11 12 16 17 11"></polyline>
                                      <line x1="12" y1="4" x2="12" y2="16"></line>
                                    </svg>
                                    Görüntüle
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="mb-3">
                  <div class="list list-row">
                    <div class="list-item">
                      <small class="d-block text-muted text-truncate mt-n1">* Termin ve tedarik koşullarına uyulmadığı
                        takdirde tarafınıza aylık % 2 ceza faturası kesilecektir.</small>
                    </div>
                    <div class="list-item">
                      <small class="d-block text-muted text-truncate mt-n1">* Kargo Gönderilerinizde YURTİÇİ KARGO veya
                        MNG KARGOYU tercih ediniz.</small>
                    </div>
                    <div class="list-item">
                      <small class="d-block text-muted text-truncate mt-n1">* Ambar gönderilerinde ÇUKUROVA AMBARI veya
                        ANADOLU EKSPRES 'i tercih ediniz.</small>
                    </div>
                    <div class="list-item">
                      <small class="d-block text-muted text-truncate mt-n1">* Teklifler kdv hariç olarak
                        verilmelidir.</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="alert alert-info" role="alert">
                <strong>SEVK ADRESİ : </strong>{{teklif.talep.sube.teslimatAdresi}}
                <!-- Çokçapınar Köyü Arşandağı Mevkii Ceyhan/ADANA -->
                <br>
                <strong>TELEFON : </strong> +90 322 636 22 02
              </div>
            </div>

            <div class="card-footer d-flex align-items-center">
              <div class="row">
                <ul class="m-0 text-right">
                  <button class="btn btn-success" (click)="teklifKaydet()" [disabled]="teklif?.durum !== 0">Teklifi
                    Kaydet</button>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>